<template>
  <FormContainer>
    <template #title>Détails complémentaires</template>
    <template #content>
      <div class="form__bloc">
        <WrapperInput
          id="field_unknown"
          :model-value="model?.employeur?.etablissement?.naf?.code"
          label="NAF"
          class="col-8 col-md-10 col-sm-36"
          :required="meta.employeur?.etablissement?.naf?.code?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.naf?.code?.$messageErreurDirty!"
          disabled
        />

        <WrapperInput
          id="field_unknown"
          :model-value="model?.employeur?.etablissement?.idcc?.code"
          label="IDCC"
          class="col-8 col-md-10 col-sm-36"
          :required="meta.employeur?.etablissement?.idcc?.code?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.etablissement?.idcc?.code?.$messageErreurDirty!"
          disabled
        />
        <WrapperInput
          id="field_unknown"
          :model-value="model?.typePublic"
          label="Type de public"
          class="col-8 col-md-10 col-sm-36"
          disabled
        />
        <WrapperInputNumber
          id="field_07"
          v-model="effectifTotalEntrepriseModel"
          label="Effectif total de l'entreprise"
          class="col-8 col-md-10 col-sm-36"
          :required="meta.employeur?.effectifTotalEntreprise?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.effectifTotalEntreprise?.$messageErreurDirty!"
          deletable
          :decimal="0"
          :separateur="true"
          :readonly
          :help="effectifHelp"
          :disabled="meta.employeur?.effectifTotalEntreprise?.$status === PropertyStatus.NotPresent"
        />
      </div>

      <div class="form__bloc">
        <WrapperDropdown
          id="field_8"
          v-model="caisseRetraitreComplementaireModel"
          label="Caisse de retraite complémentaire"
          :required="meta.employeur?.caisseRetraitreComplementaire?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.caisseRetraitreComplementaire?.$messageErreurDirty!"
          class="col-18 col-md-18 col-sm-36"
          placeholder="Ex: AG2R, APICIL, ..."
          :readonly
          :items="lov.OrganismePrevoyance"
          key-id="code"
          key-label="intitule"
        />
        <WrapperDropdown
          id="field_9"
          v-model="organismePrevoyanceModel"
          label="Organisme de prévoyance :"
          :required="meta.employeur?.organismePrevoyance?.$status === PropertyStatus.Required"
          :alertLabel="meta.employeur?.organismePrevoyance?.$messageErreurDirty!"
          class="col-18 col-md-18 col-sm-36"
          placeholder="Ex: AG2R, APICIL, ..."
          :readonly
          :items="lov.OrganismePrevoyance"
          key-id="code"
          key-label="intitule"
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { TypesContextesAutorisesEnum } from '@/features/auth/context-app'
  import { PropertyStatus } from '@/features/domaine/property-status/PropertyStatus'
  import { useDemandeCPROStore } from '@/features/interface/demande/cpro/useDemandeCPROStore'
  import { FormContainer } from '@/features/interface/demande/shared'
  import { storeToRefs } from 'pinia'
  import { computed } from 'vue'

  const store = useDemandeCPROStore()
  const { setupFieldWithKey } = store
  const { meta, model, readonly, lov, typeContextCourant } = storeToRefs(store)

  const effectifTotalEntrepriseModel = setupFieldWithKey<number>('employeur.effectifTotalEntreprise', true)

  const caisseRetraitreComplementaireModel = setupFieldWithKey<string>('employeur.caisseRetraitreComplementaire')
  const organismePrevoyanceModel = setupFieldWithKey<string>('employeur.organismePrevoyance')
  const effectifHelp = computed(() => {
    return typeContextCourant.value === TypesContextesAutorisesEnum.Adherent
      ? model.value?.sousDispositif === 'Prodiat'
        ? "L'effectif complet de tous les établissements confondus."
        : "L'effectif complet de tous les établissements confondus. Attention ce nombre aura un impact sur le versement des aides de l'état"
      : undefined
  })
</script>

